 export default {
    DirecoesEDiretores: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "direcoes-e-diretorios"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/DirecoesEDiretores.js
// module id = DaVp
// module chunks = 32